import {
  Dialog as MuiDialog,
  DialogProps as MuiDialogProps,
  IconButton,
  styled,
} from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ForwardedRef, forwardRef } from 'react';
import { useSharedTFunction } from '@shared/i18n';
import { DialogClass } from '@shared/styles';

export interface DialogProps extends MuiDialogProps {
  onClose: () => void;
  closeOnBackdropClick?: boolean;
}

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: '-14px',
  top: '-14px',
  width: '32px',
  height: '32px',
  boxShadow: theme.shadows[5],
  background: (theme.vars || theme).palette.background.paper,
  ':hover': {
    color: (theme.vars || theme).palette.common.white,
    background: (theme.vars || theme).palette.grey[900],
  },
}));

const Dialog = forwardRef((props: DialogProps, ref: ForwardedRef<HTMLDivElement>) => {
  const { onClose, closeOnBackdropClick = true, children, ...rest } = props;
  const t = useSharedTFunction();

  const handleClose = (_event: object, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick' && !closeOnBackdropClick) return;
    onClose();
  };

  return (
    <MuiDialog onClose={handleClose} {...rest} ref={ref}>
      <CloseButton
        className={DialogClass.closeButton}
        onClick={onClose}
        sx={{ zIndex: 1 }}
        aria-label={t('shared.close')}
        data-testid="dialog-close-button"
      >
        <CloseRoundedIcon fontSize={'small'} />
      </CloseButton>
      {children}
    </MuiDialog>
  );
});

export default Dialog;
